import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedActivity: null,
    fitnessBookData: null,
};

const fitnessSlice = createSlice({
    name: "fitness",
    initialState,
    reducers: {
        setSelectedActivity: (state, action) => {
            state.selectedActivity = action.payload;
        },
        resetSelectedActivity: (state) => {
            state.selectedActivity = null;
        },
        setFitnessBookedData: (state, action) => {
            state.fitnessBookData = {
                ...state.fitnessBookData,
                ...action.payload,
            };
        },
        resetFitnessBookingData: (state) => {
            state.fitnessBookData = null;
        },
    },
});

export const {
    setSelectedActivity,
    resetSelectedActivity,
    setFitnessBookedData,
    resetFitnessBookingData,
} = fitnessSlice.actions;

export default fitnessSlice.reducer;
